import { render, staticRenderFns } from "./TruncatedText.vue?vue&type=template&id=4ad11aa8&scoped=true&"
import script from "./TruncatedText.vue?vue&type=script&setup=true&lang=js&"
export * from "./TruncatedText.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TruncatedText.vue?vue&type=style&index=0&id=4ad11aa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad11aa8",
  null
  
)

export default component.exports